import Repository from './Repository'

const actionResp = 'response-comments'

export default {
  getComments(response_truck_owner_inn) {
    return Repository.get(
      actionResp +
        `?response_truck_owner_inn=${response_truck_owner_inn}&per-page=10000`,
    )
  },
  addComment(data) {
    return Repository.post(actionResp, data)
  },
}
